export {
    LINK_ABSOLUTE_URL_PATTERN,
    openLink
} from "./openLink";

export type {
    OpenLinkConstantType
} from "./openLink";
